<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="
        bg-primary 
        text-white 
        border-0 
        font-weight-bold 
        p-3 
        d-flex 
        align-items-center
      ">Pelatihan {{ this.title_tab }}
      <router-link  class="btn btn-md btn-success button-md-block px-3 ml-auto" :to="rpl_link_add" v-show="this.title_tab != 'LMS'">
        Tambah
      </router-link>
    </CCardHeader>
    
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/pelatihan/daftar-pelatihan/webinar"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="webinar-tab"
          data-toggle="tab"
          href="#webiner"
          role="tab"
          @click.native="tabchange('Webinar')"
          aria-controls="home"
          aria-selected="false">Pelatihan Webinar <span class="badge badge-success">{{ total_webinar ? total_webinar : '0' }}</span> </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/daftar-pelatihan/lms"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          @click.native="tabchange('LMS')"
          aria-controls="home"
          aria-selected="true">Pelatihan LMS <span class="badge badge-warning text-white">{{ total_lms ? total_lms : '0' }}</span></router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/daftar-pelatihan/offline"
          class="nav-link p-3 px-4 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          @click.native="tabchange('Offline')"
          aria-controls="profile"
          aria-selected="false"> Pelatihan Offline <span class="badge badge-danger">{{ total_offline ? total_offline : '0' }}</span></router-link>
      </li>
    </ul>

    <!-- Data RPL-->
    <router-view @updateCounter="updateCounter"></router-view>
    <!-- End Data RPL -->
  </CCard>
</template>
<script>
import WorkshopService from "@/services/pelatihan/workshop.service";
import PelatihanOnlineService from "@/services/pelatihan/pelatihan-online.service";

export default {
  name: "Master Sertifikasi RPL",
  data() {
    return {
        title_tab : 'LMS',
        rpl_link_add : '',
        total_lms : 0,
        total_webinar : 0,
        total_offline : 0,
        role_status: null
    };
  },
  mounted() {
    this.getCountLms();
    this.getCountWebinar();
    this.getCountOffline();
    this.mountedchange(this.$router.currentRoute.path)
    this.roleData();
  },
  watch: {
    $route (to, from){
        this.getCountLms();
        this.getCountWebinar();
        this.getCountOffline();
        this.roleData();
    }
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    updateCounter(status) {
      this.getCountLms();
      this.getCountWebinar();
      this.getCountOffline();
    },
    getCountLms() {
      PelatihanOnlineService.getWorkshop(0,10,'default',1)
      .then(response => {
        this.total_lms = response.data.total
      }).catch(error => {
        // comment console console.log(error);
      })
    },
    getCountWebinar() {
      WorkshopService.getWebinar(0, 1, 'default', 'default')
      .then(response => {
        this.total_webinar = response.data.data.totalElements;
      }).catch(error => {
          // comment console console.log(error)
      })
    },
    getCountOffline() {
      WorkshopService.getWorkshop(0, 1, 'default')
      .then(response => {
        this.total_offline = response.data.data.totalElements;
      }).catch(error => {
          // comment console console.log(error)
      })
    },
    tabchange(value) {
        
        this.title_tab = value;
        switch (value) {
          case 'LMS':
              this.rpl_link_add = ''
              break;
          case 'Webinar': 
              this.rpl_link_add = '/pelatihan/daftar-pelatihan/webinar/tambah'
              break;
          case 'Offline':
              this.rpl_link_add = '/pelatihan/daftar-pelatihan/offline/tambah'
              break;
            default:
                break;
        }
    },
    mountedchange(value) {
      switch (value) {
          case '/pelatihan/daftar-pelatihan/offline':
              this.rpl_link_add = '/pelatihan/daftar-pelatihan/offline/tambah'
              this.title_tab = 'Offline';
              break;
          case '/pelatihan/daftar-pelatihan/lms':
              this.rpl_link_add = ''
              this.title_tab = 'LMS';
              break;
          case '/pelatihan/daftar-pelatihan/webinar':
              this.rpl_link_add = '/pelatihan/daftar-pelatihan/webinar/tambah'
              this.title_tab = 'Webinar';
              break;
          default:
              break;
      }
    }
  }
};
</script>